<div class="inventory-modal">
  <div class="inventory-modal__header">
    <span class="inventory-modal__title">{{'Start New Undercarriage Rebuild Center' | translate | async}} </span>
    <i class="material-icons inventory-modal__close-button" (click)="onNoClick()" matTooltip="Close Popup">close</i>
  </div>
  <!-- <div class="center" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div> -->
  <div  class="inventory-modal__body">

    <div class="body">
      <button style="width: 50%;" mat-raised-button (click)="onClickSelectQuickIdlerSetup()">{{'Idler Setup' | translate | async}}</button>
      <button style="width: 50%;" mat-raised-button (click)="onClickSelectExistingIdler()">{{'Idler From Inventory' | translate | async}}</button>
      <button style="width: 50%;" mat-raised-button (click)="onClickSelectQuickChainSetup()">{{'Chain Setup' | translate | async}}</button>
      <button style="width: 50%;" mat-raised-button (click)="onClickSelectExistingChain()">{{'Chain From Inventory' | translate | async}}</button>

      <button style="width: 50%;" mat-raised-button (click)="onClickSelectQuickFrameSetup_()">{{'Frame Setup' | translate | async}}</button>

      <button style="width: 50%;" mat-raised-button (click)="onClickSelectExistingFrame()">{{'Frame From Inventory' | translate | async}}</button>
      <!-- <button style="width: 50%;" mat-raised-button (click)="onClickSelectExistingChainFromEquipment()">Chain From Equipment</button> -->
    
     
      <!-- <button style="width: 50%;" mat-raised-button (click)="onClickSelectExistingIdlerFromEquipment()">Idler From Equipment</button> -->
      <!-- <div>
        <span>Or</span>
      </div> -->
      <!-- <button style="width: 50%;" mat-raised-button (click)="onClickSelectNewChain()">Setup New</button>
      <button style="width: 50%;" mat-raised-button (click)="onClickSelectNewChain()">Idler Rebuild</button> -->
      
   
     </div>

     

  <!-- <div class="flex-horizontal set-margin">
    
    <mat-form-field>
      <mat-select  placeholder="Select a Chain"  [(ngModel)]="selected_chain" (selectionChange)="selectChain()">
        <mat-option *ngFor="let system of systemList" [value]="system.Id">
          {{system.SerialNumber}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field >
      <input matInput  #start_Date="ngModel" 
      [(ngModel)]="selected_date" [matDatepicker]="picker" placeholder="Choose a date">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field class="input-full-width">
      <input matInput placeholder="{{ 'Customer Reference' | translate | async }}" [(ngModel)]="selected_customerRef">
    </mat-form-field>

  </div>

  <div class="flex-horizontal set-margin">
    
    <mat-form-field class="input-full-width">
      <input matInput placeholder="{{ 'Job Number' | translate | async }}" [(ngModel)]="selected_jobNumber">
    </mat-form-field>

    <mat-form-field class="input-full-width ">
      <input matInput placeholder="{{ 'Old Job No.' | translate | async }}" [(ngModel)]="selected_oldJobNo">
    </mat-form-field>

    <mat-form-field class="input-half-width ">
      <input matInput type="number" placeholder="{{ 'Number of Link' | translate | async }}" [(ngModel)]="selected_numOfLinks">
    </mat-form-field>
    
  </div> -->

  

  
</div>
<!-- <div *ngIf="!isLoading" class="item-align-end">

  <div style="align-self: center;margin-right: 20px;" *ngIf="showErrorMessage">
    <span style="color:red;align-self: center;">An error has occurred.Check your details and Try again.</span>
  </div>

  <button mat-raised-button (click)="onClickStartInspection()">Start Inspection</button>

</div> -->

</div>